// extracted by mini-css-extract-plugin
module.exports = {"modalStyle":"_7vUl-5L1LYFNCbK-Xnlf6"};